export default __webpack_public_path__ + "6eeea1a5902a612ab151a4dd89883798.svg";